import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController,ModalController,IonRouterOutlet } from '@ionic/angular';
import { ChooseplanPage } from '../chooseplan/chooseplan.page';
import { CinfoPage } from '../cinfo/cinfo.page';
import { ClientAddPage } from '../client-add/client-add.page';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.page.html',
  styleUrls: ['./client-list.page.scss'],
})

export class ClientListPage implements OnInit {

  data:any;
  user:any;
  q:any;
  text:any;
  constructor(private routerOutlet: IonRouterOutlet,public modalController: ModalController,public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  this.user = JSON.parse(localStorage.getItem(Constant.userData));
  this.text = JSON.parse(localStorage.getItem(Constant.appText));

  }

  ngOnInit()
  {
  }

  ionViewDidEnter()
  {
    this.loadData();
  }

  async loadData()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getClient().subscribe((response:any) => {

    this.data = response.data;

    console.log(response);

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }

  async presentAlert(id) {
    const alert = await this.alertController.create({
      header: this.text.are_you_sure,
      message:this.text.want_delete,
      mode:'ios',
      buttons: [
        {
          text: this.text.cancel,
          role: 'cancel',
          handler: () => {  }
        },
        {
          text: this.text.yes,
          role: 'confirm',
          handler: () => { this.remove(id) }
        }
      ]
    });

    await alert.present();

    const { role } = await alert.onDidDismiss();

  }

  async remove(id)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.removeClient(id).subscribe((response:any) => {

    this.data = response.data;

    loading.dismiss();

    });
  }

  edit(pro)
  {
    localStorage.setItem(Constant.clientData, JSON.stringify(pro));

    this.nav.navigateForward('/client-add/'+pro.id);

  }

  async view(client) {
    const modal = await this.modalController.create({
      component: CinfoPage,
      animated:true,
      mode:'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss:true,
      swipeToClose: true,
      breakpoints: [0, 0.3, 0.5, 0.5],
      initialBreakpoint: 0.5,
      componentProps: {

        'data'  : client,
      }

    });

   modal.onDidDismiss().then(data=>{

    if(data.data.notes)
    {
    }

    })

    return await modal.present();
  }

  async addIncome(data = []) {
    const modal = await this.modalController.create({
      component: ClientAddPage,
      animated:true,
      mode:'ios',
      cssClass: 'my-custom-modal-css',
      backdropDismiss:true,
      swipeToClose: true,
      componentProps: {
        'data': data,
      }

    });

   modal.onDidDismiss().then(data=>{

    if(data.data.name)
    {
      this.add(data.data);
    }

    })

    return await modal.present();
  }

  async add(data)
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.clientAdd(data).subscribe((response:any) => {

    this.data = response.data;

    loading.dismiss();

    });
  }
}
